/* React */
import React from "react";

/* Components */
import DoubleSlider from "src/components/shared/slider/double-slider/DoubleSlider";

/* Stylesheet */
import styles from "./TimePeriod.module.scss";

/* Interfaces */
import {
  TimePeriodProps,
  FilterProps,
  FilterType,
} from "src/shared/interfaces/insights-filter/InsightsFilter";

const TimePeriod: React.FC<{
  item: FilterProps<TimePeriodProps>;
  handleValue: (
    key: FilterType,
    value: TimePeriodProps
  ) => void;
}> = ({ item, handleValue }) => {
  const value = item.value ?? item.initialValue!;
  const previous = item.previousValue;

  const firstYear =
    value?.firstYear ??
    previous?.firstYear ??
    item.initialValue!.firstYear;

  const lastYear =
    value?.lastYear ??
    previous?.lastYear ??
    item.initialValue!.lastYear;

  const firstYearInitialValue = parseInt(
    item.initialValue!.firstYear,
    10
  );
  const lastYearInitialValue = parseInt(
    item.initialValue!.lastYear,
    10
  );

  const disabled =
    firstYearInitialValue === lastYearInitialValue ||
    item.disabled;

  return (
    <div className={styles.time_period}>
      <DoubleSlider
        scssProps={{
          padding: "21px 0px 21px 0px",
        }}
        className={"dark"}
        label={"Time Period"}
        min={firstYearInitialValue}
        max={lastYearInitialValue}
        value={{
          lower: parseInt(firstYear, 10),
          upper: parseInt(lastYear, 10),
        }}
        pin={true}
        ticks={true}
        disabled={disabled}
        onChange={({ lower, upper }) => {
          handleValue(FilterType.TIME_PERIOD, {
            firstYear: lower.toString(),
            lastYear: upper.toString(),
          });
        }}
      />
    </div>
  );
};

export default TimePeriod;
